var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.65C0.8067 2.65 0.65 2.8067 0.65 3C0.65 3.1933 0.8067 3.35 1 3.35V2.65ZM7.24749 3.24749C7.38417 3.1108 7.38417 2.8892 7.24749 2.75251L5.0201 0.525126C4.88342 0.388443 4.66181 0.388443 4.52513 0.525126C4.38844 0.66181 4.38844 0.883418 4.52513 1.0201L6.50503 3L4.52513 4.9799C4.38844 5.11658 4.38844 5.33819 4.52513 5.47487C4.66181 5.61156 4.88342 5.61156 5.0201 5.47487L7.24749 3.24749ZM1 3.35H7V2.65H1V3.35Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2c51d3e584795cd61d20e983c4543511.svg";
export { ForwardRef as ReactComponent };